import type { Dispatch, SetStateAction } from 'react';

export type ToastAktion = { label: string; onClick: () => void };
export type ToastEntry = { id: number; message: string; type: 'success' | 'error' | 'info'; exiting?: boolean; aktion?: ToastAktion };

let _toastSetter: Dispatch<SetStateAction<ToastEntry[]>> | null = null;
let _toastId = 0;

export function registerToastSetter(fn: Dispatch<SetStateAction<ToastEntry[]>> | null) {
  _toastSetter = fn;
}

// Welle U3b: optional mit Aktion (z.B. "Rückgängig") und eigener Anzeigedauer
export function toast(message: string, type: ToastEntry['type'] = 'success', opts: { aktion?: ToastAktion; dauerMs?: number } = {}) {
  if (!_toastSetter) return;
  const id = ++_toastId;
  _toastSetter(prev => [...prev, { id, message, type, aktion: opts.aktion }]);
  setTimeout(() => {
    _toastSetter?.(prev => prev.map(t => t.id === id ? { ...t, exiting: true } : t));
    setTimeout(() => {
      _toastSetter?.(prev => prev.filter(t => t.id !== id));
    }, 200);
  }, opts.dauerMs ?? 2000);
}

// Toast sofort schließen (z.B. nachdem seine Aktion ausgelöst wurde)
export function schliesseToast(id: number) {
  _toastSetter?.(prev => prev.filter(t => t.id !== id));
}
